import { render, staticRenderFns } from "./childrenEducation.vue?vue&type=template&id=25533d50&scoped=true"
import script from "./childrenEducation.vue?vue&type=script&lang=js"
export * from "./childrenEducation.vue?vue&type=script&lang=js"
import style0 from "./childrenEducation.vue?vue&type=style&index=0&id=25533d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25533d50",
  null
  
)

export default component.exports